import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { protocols } from "../../../../config/constants";
import { getValidProtocols } from "../../../../config/validateProtocols";
import { GetClinicAndHomeProtocolData } from "../getProtocolData/clinicAndHome";
// Components
import PrescriptionsHeader from "../prescriptionsHeader";
import ProtocolPrescription from "../protocolPrescription";

const ClinicAndHomeProtocols = ({
  software,
  prescriptions,
  prescriptionsOrder,
  setPrescriptionsOrder,
  prescriptionsToDatabase,
  hospitalProtocols,
  protocolsSessionsNumber,
  isDisabledInputs,
  isColorToggleActive,
}) => {
  const { patientId } = useParams();
  const [t] = useTranslation("global");

  const getProtocolPrescriptions = (protocolId) => {
    return prescriptions.filter((prescription) => prescription.PROTOCOL_ID === protocolId);
  };

  const renderProtocols = () => {
    const clinicAndHomeProtocols = Object.values(protocols.clinicAndHome);
    const orderedClinicAndHomeProtocols = getValidProtocols(clinicAndHomeProtocols, hospitalProtocols);

    if (orderedClinicAndHomeProtocols.length) {
      return orderedClinicAndHomeProtocols.map((orderedProtocol) => {
        const protocolId = orderedProtocol.PROTOCOL_ID;
        const protocolPrescriptions = getProtocolPrescriptions(protocolId);
        const protocolSessions = protocolsSessionsNumber.find((protocol) => protocol.PROTOCOL_ID === protocolId);
        const sessionsNumber = protocolSessions ? protocolSessions.sessionsNumber : 0;
        const { img, name } = GetClinicAndHomeProtocolData(protocolId);

        return (
          <ProtocolPrescription
            key={protocolId}
            protocolId={protocolId}
            protocolImg={img}
            protocolName={t(`protocols_${name}`)}
            prescriptions={protocolPrescriptions}
            prescriptionsOrder={prescriptionsOrder}
            setPrescriptionsOrder={setPrescriptionsOrder}
            totalPrescriptions={prescriptions}
            prescriptionsToDatabase={prescriptionsToDatabase}
            isDisabledInputs={isDisabledInputs}
            patientId={patientId}
            software={software}
            sessionsNumber={sessionsNumber}
            isColorToggleActive={isColorToggleActive}
          />
        );
      });
    }
  };

  return (
    <>
      <PrescriptionsHeader software={software} />
      {renderProtocols()}
    </>
  );
};

export default ClinicAndHomeProtocols;
